import React from "react";
import { forwardRef } from "react";
// material
import { Avatar, SxProps, useTheme } from "@mui/material";

type Props = {
  children: React.ReactNode;
  sx: SxProps;
  color:
    | "default"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error";
};

const MAvatar = forwardRef<any, Props>(
  ({ color = "default", sx, children, ...other }: Props, ref) => {
    const theme = useTheme();

    if (color === "default") {
      return (
        <Avatar ref={ref} sx={sx} {...other}>
          {children}
        </Avatar>
      );
    }

    return (
      <Avatar
        ref={ref}
        sx={{
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette[color].contrastText,
          backgroundColor: theme.palette[color].main,
          ...sx,
        }}
        {...other}
      >
        {children}
      </Avatar>
    );
  }
);

export default MAvatar;
